import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Assuming you're using axios for API calls
import ExceptionsList from './ExceptionsList';
import { fetchOrderExceptiosn } from '../../api/OrdersApi';
import I18n from '../../common/I18n';
import ItemsExceptionLogList from './ItemsExceptionList';
import OrderItemExceptionList from './OrderItemExcpetionList';

const OrderExceptions = ({ currentOrder, currentOrg, isMilitaryTime, fromIndividualScreen }) => {
  const [orderExceptions, setOrderExceptions] = useState([]);
  const [itemExceptions, setItemExceptions] = useState([]);

  useEffect(() => {
    const fetchExceptions = async () => {
      try {
        if (currentOrder?.id) {
          const response = await fetchOrderExceptiosn(currentOrder.id);
          if (response.success) {
            setItemExceptions(response?.data?.item_exceptions || []);
            setOrderExceptions(response?.data?.order_exceptions || []);
            // setOrderExceptions([])
            // setItemExceptions([])

          } else {
            setOrderExceptions([])
            setItemExceptions([])
          }
        }
      } catch (error) {
        console.error('Error fetching exceptions:', error);
      }
    };
    fetchExceptions();
  }, [currentOrder?.id]);

  return (
    <div className='order-exceptions-tab'>
      <h3>{I18n.t("exceptions.orderException")}</h3>
      <ExceptionsList
        data={orderExceptions}
        pagination={{ position: 'none' }}
        size="small"
        timeZone={currentOrder.timeZoneId}
        timeZoneName={currentOrder.tz_short_name}
        isMilitaryTime={isMilitaryTime}
        scroll={{ y: fromIndividualScreen ? "calc(100vh - 290px)" : "calc(100vh - 180px)" }}
      />

      <h3 className='item-exception'>{I18n.t("exceptions.itemException")}</h3>
      <OrderItemExceptionList
        data={itemExceptions}
        pagination={{ position: 'none' }}
        size="small"
        timeZone={currentOrder.timeZoneId}
        timeZoneName={currentOrder.tz_short_name}
        isMilitaryTime={isMilitaryTime}
        scroll={{ y: fromIndividualScreen ? "calc(100vh - 290px)" : "calc(100vh - 180px)" }}
      />

    </div>
  );
};

export default OrderExceptions;
